import { buildSlice, CommonState } from '~libs/reduxUtils';

import { SectionItem } from '~support-at-home/models';

import { getAll, getBudgetExternalServices, typePrefix } from '~support-at-home/actions/budgetServices';

const initialState: CommonState<SectionItem> = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  rows: [],
};

const slice = buildSlice<CommonState<SectionItem>, SectionItem>(typePrefix, initialState, {
  commonConfig: { getAll },
  extraReducers: (builder) => {
    builder.addCase(getBudgetExternalServices.fulfilled, (state, action) => {
      state.rows = action.payload.data;
      state.loading = 'fulfilled';
    });
  },
});

export const { clear } = slice.actions;
export default slice.reducer;
